import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';

import Select, { SelectItem } from '../ui/Select';
import ApplicationContext from '../ApplicationContext';
import { ComboParamsBase, CompanyParams, FmsComboType } from '../fms.core/constants';
import { FmsCompany } from '../fms.core/FmsCompany';

function CompanyDropDown({
  value,
  onChange = () => {},
  disabled = false,
  items = [],
  name=undefined,
}: {
  value: number | null | undefined,
  onChange?: (x:FmsCompany|null) => void,
  disabled?: boolean,
  items?: Array<FmsCompany>,
  name?: string|undefined,
}) {
  const appContext = useContext(ApplicationContext);

  const [data, setData] = useState<Array<any>>([]);

  async function fetchData(api:any) {
    //const apiResult = await api.getCodesCompanyUsers();
    //setData(apiResult && apiResult.data ? apiResult.data : []);
    var base = new ComboParamsBase();
    base.comboType = FmsComboType.OrchidCompany;
   const data = await api.loadCodeData([new CompanyParams()]);
    if (data && data.length > 0) {
      setData(data[0].items);
    }
  }

  function handleChange(e:React.ChangeEvent<HTMLInputElement>) {
    if (!e.target.value) {
      onChange(null);
      return;
    }
    
    const element = data.find(x => x.id === Number(e.target.value));
    onChange(element ?? null);
  }

  useEffect(() => {
      if (items && items.length > 0) {
        setData(items);
      } else {
        fetchData(appContext.api);
      }
      return () => {
        setData([]);
        }
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const displayData:Array<SelectItem> = [
    {value: 0, label: 'ALL' },
    ...data.map(x => ({value: x.id?? 0, label: x.sName ?? ''}))
  ];

  return (
    <Select
      name={name}
      value={(value === null || value === undefined) ? '' : Number(value)}
      onChange={handleChange}
      disabled={disabled}
      items={displayData}
    />
  );
}

CompanyDropDown.defaultProps = {
  onChange: () => {},
  disabled: false,
  dark: false,
};

CompanyDropDown.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  dark: PropTypes.bool.isRequired,
  items: PropTypes.array,
};

export default React.memo(CompanyDropDown);
